// validation regex
const PHONE_NUMBER = /^\+[1-9]([.\- ]?[0-9]+){6,15}$/;
const URL_VALIDATION = /(^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1})/;
const FACEBOOK_VALIDATION = /^https:\/\/(www.)?facebook.com\/.+$/;
const TWITTER_VALIDATION = /^https:\/\/(www.)?twitter.com\/.+$/;
const INSTA_VALIDATION = /^https:\/\/(www.)?instagram.com\/.+$/;
export { PHONE_NUMBER, URL_VALIDATION, FACEBOOK_VALIDATION, TWITTER_VALIDATION, INSTA_VALIDATION };
